import { apiRoot } from "@/config/config";
import axios from "axios";

export async function calc_mixture_properties(
  cas_list: any,
  zs: any,
  T: any = 298.15,
  P: any = 101325,
  method: any = 'SRK'
) {
  return await axios({
    url: `${apiRoot}/mixture/calc_mixture_properties`,
    data: {
      cas_list,
      zs,
      T,
      P,
      method,
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    method: 'post',
  });
}

//获取所有物质列表
export async function getMaterials(params: any) {
  return await axios({
    url: `${apiRoot}/read_identification`,
    params,
    method: "get",
  });
}

//获取所有属性列表列表
export async function getPropsNames() {
  return await axios({
    url: `${apiRoot}/read_PureComponent`,
    method: "get",
  });
}
//查询纯组分的全部温压无关物性数据
export async function get_properties_from_cas(cas: any) {
  return await axios({
    url: `${apiRoot}/get_properties_from_cas`,
    // withCredentials: true,                // 允许携带 cookie
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    data: { cas },
    // headers: { 'Content-Type': 'application/json' } ,
    method: "POST",
  });
}
//查询纯组分的全部温度有关的物性数据
export async function get_T_dep_properties_from_cas(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_T_dep_properties_from_cas`,
    data: { cas, T },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}

/**********各个温度相关的灵敏度查询*****************/

//水中的溶解度灵敏度
export async function get_Liquid_Heat_Capacity_Sensitivity(
  cas: string,
  T_start: number,
  T_end: number,
  T_step: number
) {
  return await axios({
    url: `${apiRoot}/get_Liquid_Heat_Capacity_Sensitivity`,
    data: {
      cas,
      T_start,
      T_end,
      T_step,
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    method: 'post',
  });
}

//汽相导热率灵敏度
export async function get_Gas_Thermal_Conductivity_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Gas_Thermal_Conductivity_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//液相导热率灵敏度
export async function get_Liquid_Thermal_Conductivity_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Liquid_Thermal_Conductivity_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//理想气体定压热容灵敏度
export async function get_Ideal_Gas_Heat_Capacity_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Ideal_Gas_Heat_Capacity_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//固体热容灵敏度
export async function get_Solid_Heat_Capacity_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Solid_Heat_Capacity_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//蒸发焓灵敏度
export async function get_Heat_of_Vaporization_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Heat_of_Vaporization_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//液相摩尔密度灵敏度
export async function get_Molar_Liquid_Density_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Molar_Liquid_Density_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//固体摩尔密度灵敏度
export async function get_Molar_Solid_Density_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Molar_Solid_Density_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//液相黏度灵敏度
export async function get_Liquid_Viscosity_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Liquid_Viscosity_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//气相黏度灵敏度
export async function get_Gas_Viscosity_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Gas_Viscosity_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//气‑液平衡饱和蒸汽压灵敏度
export async function get_Saturation_Vapor_Pressure_Gas_Liquid_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Saturation_Vapor_Pressure_Gas_Liquid_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//气‑固平衡饱和蒸汽压灵敏度
export async function get_Saturation_Vapor_Pressure_Gas_Solid_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Saturation_Vapor_Pressure_Gas_Solid_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//表面张力灵敏度
export async function get_Surface_Tension_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Surface_Tension_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//水中的溶解度灵敏度
export async function get_Solubility_in_Water_Sensitivity(cas: string, T_start:number, T_end:number, T_step:number) {
  return await axios({
    url: `${apiRoot}/get_Solubility_in_Water_Sensitivity`,
    data: { 
      cas,
      T_start,
      T_end,
      T_step
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}


/**********各个温度相关的单一温度查询*****************/
//查询 液相导热率
export async function get_Liquid_Thermal_Conductivity(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Liquid_Thermal_Conductivity`,
    data: { cas, T },
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: "post",
  });
}
//查询 气相导热率
export async function get_Gas_Thermal_Conductivity(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Gas_Thermal_Conductivity`,
    data: { cas, T },
    method: "post",
  });
}
//查询 理想气体Cp
export async function get_Ideal_Gas_Heat_Capacity(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Ideal_Gas_Heat_Capacity`,
    data: { cas, T },
    method: "post",
  });
}
//查询 固体Cp
export async function get_Solid_Heat_Capacity(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Solid_Heat_Capacity`,
    data: { cas, T },
    method: "post",
  });
}
//查询 蒸发焓
export async function get_Heat_of_Vaporization(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Heat_of_Vaporization`,
    data: { cas, T },
    method: "post",
  });
}
//查询 液相摩尔密度
export async function get_Molar_Liquid_Density(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Molar_Liquid_Density`,
    data: { cas, T },
    method: "post",
  });
}
//查询 固相摩尔密度
export async function get_Molar_Solid_Density(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Molar_Solid_Density`,
    data: { cas, T },
    method: "post",
  });
}
//查询 液体黏度
export async function get_Liquid_Viscosity(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Liquid_Viscosity`,
    data: { cas, T },
    method: "post",
  });
}
//查询 气体黏度
export async function get_Gas_Viscosity(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Gas_Viscosity`,
    data: { cas, T },
    method: "post",
  });
}
//查询 气‑液饱和压
export async function get_Saturation_Vapor_Pressure_Gas_Liquid(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Saturation_Vapor_Pressure_Gas_Liquid`,
    data: { cas, T },
    method: "post",
  });
}
//查询 气‑固饱和压
export async function get_Saturation_Vapor_Pressure_Gas_Solid(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Saturation_Vapor_Pressure_Gas_Solid`,
    data: { cas, T },
    method: "post",
  });
}
//查询 表面张力
export async function get_Surface_Tension(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Surface_Tension`,
    data: { cas, T },
    method: "post",
  });
}
//查询 表面张力
export async function get_Solubility_in_Water(cas: string, T: any) {
  return await axios({
    url: `${apiRoot}/get_Solubility_in_Water`,
    data: { cas, T },
    method: "post",
  });
}
